import axios from 'axios';

// إعادة المحاولة تلقائياً لطلبات GET لو فشلت بسبب الشبكة أو خطأ سيرفر مؤقت.
// سيرفر التطوير (php artisan serve) بيخدم طلب واحد في المرة، فالطلبات المتزامنة
// ممكن تتقطع أحياناً — المحاولة التانية غالباً بتنجح.
const MAX_RETRIES = 2;
const RETRYABLE_STATUS = new Set([502, 503, 504]);

const isRetryable = (error) => {
  const config = error.config;
  if (!config || (config.method || 'get').toLowerCase() !== 'get') return false;
  if (axios.isCancel(error)) return false;
  if (!error.response) return true; // Network Error / connection reset
  return RETRYABLE_STATUS.has(error.response.status);
};

axios.interceptors.response.use(undefined, async (error) => {
  if (!isRetryable(error)) return Promise.reject(error);

  const config = error.config;
  config.__retryCount = (config.__retryCount || 0) + 1;
  if (config.__retryCount > MAX_RETRIES) return Promise.reject(error);

  await new Promise((resolve) => setTimeout(resolve, 400 * config.__retryCount));
  return axios(config);
});
